import React from 'react';
import PropTypes from 'prop-types';
import {action} from 'mobx';
import {withRouter, locationShape} from 'react-router';

import withI18n from 'spa/Components/Context/withI18n';

import './ZopimCustom.less';

import {cn} from 'spa/css';

@withRouter
@withI18n
class ChatButton extends React.Component {
  static propTypes = {
    enabled: PropTypes.bool,
    location: locationShape.isRequired,
  };

  UNSAFE_componentWillMount() {
    const {location} = this.props;
    const {pathname} = location;

    if (pathname.indexOf('/lp/') >= 0) {
      this.isLandingPage = true;
    }
  }

  @action openChat = (event) => {
    if (event) event.preventDefault();

    window.$zopim.livechat.window.show();
  }

  render() {
    const {isLandingPage} = this;
    const {i18n} = this.context;
    return (
      <button
        className={cn(
          'chat-button',
          isLandingPage && 'chat-button--landing-page',
        )}
        onClick={this.openChat}
      >
        <span className="chat-button__text">{i18n.__('chat')}</span>
      </button>
    );
  }
}

export default ChatButton;



// WEBPACK FOOTER //
// ./spa/Components/ChatButton.jsx